import { render, staticRenderFns } from "./BriqCheckboxStandalone.vue?vue&type=template&id=6f86ec08&scoped=true&lang=pug&"
import script from "./BriqCheckboxStandalone.vue?vue&type=script&lang=js&"
export * from "./BriqCheckboxStandalone.vue?vue&type=script&lang=js&"
import style0 from "./BriqCheckboxStandalone.vue?vue&type=style&index=0&id=6f86ec08&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86ec08",
  null
  
)

export default component.exports